import { jwtToAuthUser } from '@stayon/auth-core';
import { identityKey } from '@/shared/auth/sessionIdentity';
import { IdentityChangedError, SupportSessionEndedError } from './supportBearer';

/**
 * Kontext einer Api, die an die Identität gebunden ist, unter der der Tab sie ausgegeben hat:
 * Benutzer, Workspace und gegebenenfalls Support-Sitzung (`identityKey`).
 */
export const boundTo = (identity: string) => ({ identity });

/**
 * Ein Request geht nur mit einem Token der Identität raus, die ihn angestoßen hat. Ein Upload, der
 * nach „Beenden“ weiterläuft, träfe sonst mit dem Heimat-Token den eigenen Workspace — und ein
 * Anlegen ohne Elternobjekt landete dort. Eine Api ohne Bindung prüft nichts.
 */
export function assertIdentity(
  context: Record<string, unknown>,
  token: string | null | undefined,
): void {
  const bound = context.identity;
  if (typeof bound !== 'string') return;
  if (identityKey(token ? jwtToAuthUser(token) : null) === bound) return;
  throw bound.split('|')[2] ? new SupportSessionEndedError() : new IdentityChangedError();
}
